import { Injectable } from "@angular/core";
import { ApiService } from "../global.service";
import { Observable } from "rxjs";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { ConfigService } from "../config.service";
import { LocalStorageService } from "../storage.service";
import { BusinessContextService } from "../business-context.service";

export interface SavedGroupDTO {
  gid: string;
  color: string;
  itemUuids: string[];
  createdAt: number;
  name?: string;
  paymentUuid?: string;
}

@Injectable({ providedIn: 'root' })
export class SavedGroupsService extends ApiService {
  constructor(
    public override http: HttpClient,
    public override config: ConfigService,
    public override localStorageService: LocalStorageService,
    handler: HttpBackend,
    private bizCtx: BusinessContextService,
  ) {
    super(http, config, localStorageService, handler);
  }

  private getBusiness(): string { return this.bizCtx.getSelected() || this.CUSTOMER; }

  // GET /order-groups/{orderUuid} (business via header)
  list(orderUuid: string): Observable<SavedGroupDTO[]> {
    return this.get<SavedGroupDTO[]>(`${this.URL}/order-groups/${orderUuid}`);
  }

  // POST /order-groups/{orderUuid}
  // Persiste grupos (backend genera gid/createdAt; si existen, no inserta)
  save(orderUuid: string, groups: SavedGroupDTO[]): Observable<{ ok: boolean }> {
    const payloadGroups = (Array.isArray(groups) ? groups : []).map(g => ({
      uuid: String((g as any)?.uuid ?? g.gid ?? ''),
      name: typeof g.name === 'string' ? g.name : '',
      color: typeof g.color === 'string' ? g.color : '#748FFC',
      itemUuids: Array.isArray(g.itemUuids) ? g.itemUuids.map(u => String(u)) : [],
      paymentUuid: (g && (g as any).paymentUuid) ? String((g as any).paymentUuid) : ''
    }));
    return this.create<{ ok: boolean }>(`${this.URL}/order-groups/${orderUuid}`, { groups: payloadGroups });
  }

  // DELETE /order-groups/{groupUuid}/items/{itemUuid}
  // Desasocia un ítem de un grupo específico
  removeItemFromGroup(groupUuid: string, itemUuid: string): Observable<{ ok: boolean } | any> {
    const g = String(groupUuid || '').trim();
    const i = String(itemUuid || '').trim();
    if (!g || !i) throw new Error('groupUuid y itemUuid son requeridos');
    const url = `${this.URL}/order-groups/${g}/items/${i}`;
    return this.delete<{ ok: boolean }>(url);
  }

  // POST /order-groups/{groupUuid}/items
  // Asocia uno o más ítems a un grupo específico
  addItemsToGroup(groupUuid: string, itemUuids: string[]): Observable<{ ok: boolean } | any> {
    const g = String(groupUuid || '').trim();
    const arr = Array.isArray(itemUuids) ? itemUuids.map(u => String(u).trim()).filter(Boolean) : [];
    if (!g || arr.length === 0) throw new Error('groupUuid y itemUuids son requeridos');
    const url = `${this.URL}/order-groups/${g}/items`;
    return this.create<{ ok: boolean }>(url, { itemUuids: arr });
  }
}